<script lang="ts" setup>
withDefaults(
  defineProps<{
    isAutoplay?: boolean
    isButtons?: boolean
    isLoop?: boolean
  }>(),
  { isAutoplay: false, isButtons: true, isLoop: false }
)
</script>
<template>
  <div class="relative max-w-full overflow-x-clip overflow-y-visible [&_*]:!cursor-grab [&_*]:select-none">
    <Carousel
      class="!w-full !max-w-full whitespace-nowrap !p-0 [&_.embla-content]:!overflow-visible"
      drag-free
      :is-autoplay="isAutoplay"
      :is-loop="isLoop"
      :show-buttons="isButtons"
    >
      <div class="embla-box flex items-stretch">
        <slot />
      </div>
    </Carousel>
  </div>
</template>
